import { createFileRoute } from '@tanstack/react-router';

import { ProductId } from './-components/productId';

function ProductPage() {
  const { productId } = Route.useParams();
  return <ProductId productId={productId} />;
}

export const Route = createFileRoute('/sample/products/$productId')({
  component: ProductPage,
});
